import type { ConnectivityPage } from '../../data'
import { ago } from './format'

const TONE: Readonly<Record<string, string>> = { grant: 'is-grant', revoke: 'is-revoke', network: 'is-network' }

/** What changed, newest first, each written by the change itself. */
export function Recent({ events }: { events: ConnectivityPage['events'] }): JSX.Element {
  return (
    <section className="cx-panel cx-panel--padded" aria-label="Recent changes">
      <h2 className="cx-panel__title">Recent changes</h2>
      {events.length === 0 ? <p className="muted">Nothing yet.</p> : null}
      <ul className="cx-events">
        {events.slice(0, 12).map((e, i) => (
          <li key={`${e.at}-${i}`} className="cx-event">
            <span className={`cx-event__dot ${TONE[e.kind] ?? ''}`} aria-hidden="true" />
            <span className="stack" style={{ gap: 2 }}>
              <span>
                <strong>{e.byName ?? 'Kronos'}</strong> {e.text}
              </span>
              <span className="muted cx-small">{ago(e.at)}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
